import { useCallback } from 'react';
import { useAppDispatch } from '../../../../../../app/store';
import { 
  moveScheduledProcedureCodeUpAction, 
  moveScheduledProcedureCodeDownAction 
} from '../../../../../../services/EncounterService/slice';

/**
 * Hook for handling scheduled procedure code grid actions (move up/down)
 */
export function useScheduledProcedureCodeActions() {
  const dispatch = useAppDispatch();

  const handleMoveUp = useCallback(
    (id: string, event?: React.MouseEvent) => {
      event?.stopPropagation();
      dispatch(moveScheduledProcedureCodeUpAction(id));
    },
    [dispatch]
  );

  const handleMoveDown = useCallback(
    (id: string, event?: React.MouseEvent) => {
      event?.stopPropagation();
      dispatch(moveScheduledProcedureCodeDownAction(id));
    },
    [dispatch]
  );

  return { handleMoveUp, handleMoveDown };
}
